import Star from '../../assets/review-star.png';

export const ReviewStar = () => {
  return (
    <div className="LL-ReviewStar" role="presentation">
      <img src={Star} alt="Review Star" height={15} />
    </div>
  );
};
